export const lightMode = {
    colors: {
        background: "#FBFBFE",
        textPrimary: "#252525",
        textSecondary: "#6E7E91",
        primary: "#0366D6",
        tileBackground: "#FFFFFF",
        border: "rgba(209, 213, 218, 0.3)",
        boxBackground: "#FFFFFF",
        tileShadow: "0px 16px 58px rgba(9, 10, 51, 0.03)",
        tileBorder: "rgba(209, 213, 218, 0.3)",
        headerLine: "rgba(209, 213, 218, 0.3)",
    },
    breakpoints: {
        mobile: 767,
    },
};

export const darkMode = {
    colors: {
        background: "#252525",
        textPrimary: "#FFFFFF",
        textSecondary: "#D1D5DA",
        primary: "#2188FF",
        tileBackground: "rgba(54, 54, 54, 0.72)",
        border: "rgba(209, 213, 218, 0.1)",
        boxBackground: "rgba(54, 54, 54, 0.72)",
        tileShadow: "none",
        tileBorder: "rgba(209, 213, 218, 0.1)",
        headerLine: "rgba(209, 213, 218, 0.1)",
    },
    breakpoints: {
        mobile: 767,
    },
};

